import { render, staticRenderFns } from "./BCheckbox.vue?vue&type=template&id=33956279&"
import script from "./BCheckbox.vue?vue&type=script&lang=js&"
export * from "./BCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports